/**
 * 隐藏loading
 */
export function hideLoading() {
  const loadingContainer = document.getElementById('loading-container');
  if (loadingContainer) {
    loadingContainer.style.display = 'none';
  }
}
